import React from 'react';

const LoaderText = (props) => {

	return (
		<div className="loader loader-text">
			<div className="inner">
				<div className="circle">
					<img src={'/images/loader-anim-inline.svg'} alt="loading..." className="not-ie" />
					<img src={'/images/loader-anim-inline-ie.gif'} alt="loading..." className="ie" />
				</div>
				<div className="text">
					<span>{props.title}</span>
					<br />
					<small>{props.subTitle}</small>
				</div>
			</div>
		</div>
	);

};

export default LoaderText;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/LoaderText.js